<router-outlet />

<app-modal-spinner [open]="!!(busy|async)">
    <span class="material-symbols-outlined spinner" style="font-size:48px;margin:.5em;">
        progress_activity
    </span>
    {{ messages | async }}
</app-modal-spinner>

@let error = error$ | async;
@if (!!error) {
    <app-modal-spinner [open]="true">
        <span class="material-symbols-outlined" style="font-size:48px;margin:.5em;">
            error
        </span>
        <p style="font-size: 16px;word-wrap: break-word;"><b>{{ error.status }}</b>: {{ 'app.failure' |translate }}</p>
        <app-button (click)="dismissError()" variant="secondary" >{{'app.OK'|translate}}</app-button>
    </app-modal-spinner>
}

@let renameData = renamer.showRenameModal();
<app-modal-generic [open]="!!renameData" label="Reanomena font de risc" style="justify-content: space-between;">
    <section style="width:100%">
        <h3 style="margin-top:0;padding:1rem;background: var(--gradient-primary);color:white;width: 100%;" 
            translate [translateParams]="renameData!">
            app.renameRS
        </h3>
        <!-- <p>{{renameData | json}}</p> -->
        <input type="text" style="padding:.6rem;border-radius:1rem; border:solid 0px white;width: 80%;margin:0 1rem" 
            placeholder="Introdueix el nou nom" [formControl]="nameControl" #name>
    </section>
    <footer style="display: flex;justify-content: space-between; width:80%">
        <app-button (click)="renamer.showRenameModal.set(undefined);renamer.renamedTo(undefined)" variant="secondary">
            {{'app.cancel'|translate}}
        </app-button>
        <app-button [disabled]="!nameControl.value" (click)="requestRename(nameControl.value!)" variant="secondary">
            {{'app.done'|translate}}
        </app-button>
    </footer>
    
</app-modal-generic>
